// extracted by mini-css-extract-plugin
export default {"container":"Switch_container__P2QeA","switch":"Switch_switch__sM-Ab","label":"Switch_label__gYa1B","disabled":"Switch_disabled__HOw8L"};